import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "absolute -left-[9999px]",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "text-red-600 w-full justify-center text-sm font-bold py-2 h-12 items-end flex" }
const _hoisted_3 = { class: "text-sm mt-2 mb-[76px]" }
const _hoisted_4 = { class: "mt-2 leading-6 text-gray-500 dark:text-gray-400 flex justify-center" }

import requestAccount from '@/utilities/requestAccountApi'

	// vue
	import {
		ref,
		computed
	} from 'vue'

	
	const __default__ = { name: 'RequestAccountForm' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// api
	const name = ref("")
	const company = ref("")
	const email = ref("")
	const rawPhone = ref("")
	const honeypot = ref("")
	const loading = ref(false)
	const message = ref<string>('')
	const submitted = ref(false)

	const turnstileRef = ref<{ execute: () => Promise<string> } | null>(null)

	// strips non-digits and formats the phone field as xxx-xxx-xxxx while the user types
	function formatPhone(value: string): string {
		const digits = value.replace(/\D/g, '').slice(0, 10)

		if (digits.length <= 3) {
			return digits
		}
		else if (digits.length <= 6) {
			return `${digits.slice(0, 3)}-${digits.slice(3)}`
		}
		else {
			return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
		}
	}

	// formats on every keystroke so non-digits never render, even briefly;
	// the DOM value is forced directly because tw-input skips its own re-render
	// when the formatted result matches the previous value (e.g. a stripped letter)
	const phone = computed({
		get: () => rawPhone.value,
		set: (value: string) => {
			const formatted = formatPhone(value)
			rawPhone.value = formatted

			const input = document.getElementById('phone') as HTMLInputElement | null
			if (input) {
				input.value = formatted
			}
		}
	})

	// submits the request account form; a filled honeypot field is silently treated as success
	async function submitRequest() {
		try {
			loading.value = true
			message.value = ""

			// check for empty field values
			if (name.value == "") {
				document.getElementById('name')?.focus()
				throw 'Empty name'
			}
			else if (company.value == "") {
				document.getElementById('company')?.focus()
				throw 'Empty company'
			}
			else if (email.value == "") {
				document.getElementById('email')?.focus()
				throw 'Empty email'
			}

			if (honeypot.value) {
				submitted.value = true
				return
			}

			const token = await turnstileRef.value?.execute() ?? ""

			const response = await requestAccount({
				name: name.value,
				company: company.value,
				email: email.value,
				phone: phone.value,
				honeypot: honeypot.value,
				token,
			})

			if (response.result === 'OK') {
				submitted.value = true
			}
			else {
				message.value = "There was an issue submitting your request. Please try again or contact us for assistance."
			}
		}
		catch (error: any) {
			message.value = "There was an issue submitting your request. Please try again or contact us for assistance."
		}
		finally {
			loading.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_cloudflare_turnstile = _resolveComponent("cloudflare-turnstile")!
  const _component_tw_button = _resolveComponent("tw-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (submitRequest()), ["prevent"])),
        class: "space-y-6"
      }, [
        _createElementVNode("div", null, [
          _createVNode(_component_tw_input, {
            modelValue: name.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
            id: "name",
            name: "name",
            required: true,
            type: "text",
            autocomplete: "name",
            label: "Name (required)",
            validation: "Please enter your name."
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_tw_input, {
            modelValue: company.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((company).value = $event)),
            id: "company",
            name: "company",
            required: true,
            type: "text",
            autocomplete: "organization",
            label: "Company (required)",
            validation: "Please enter your company."
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_tw_input, {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email).value = $event)),
            id: "email",
            name: "email",
            required: true,
            type: "email",
            autocomplete: "email",
            label: "Email address (required)",
            validation: "Please enter your email address."
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_tw_input, {
            modelValue: phone.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((phone).value = $event)),
            id: "phone",
            name: "phone",
            required: false,
            type: "tel",
            autocomplete: "tel",
            label: "Phone"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_1, [
          _cache[6] || (_cache[6] = _createElementVNode("label", {
            for: "website",
            class: "sr-only"
          }, "Leave this field blank", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((honeypot).value = $event)),
            type: "text",
            id: "website",
            name: "website",
            tabindex: "-1",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, honeypot.value]
          ])
        ]),
        _createVNode(_component_cloudflare_turnstile, {
          ref_key: "turnstileRef",
          ref: turnstileRef
        }, null, 512),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(message.value), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_tw_button, {
              type: "submit",
              class: "btn-db-yellow w-full",
              disabled: loading.value,
              loading: loading.value
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" Submit Request ")
              ])),
              _: 1,
              __: [7]
            }, 8, ["disabled", "loading"])
          ])
        ])
      ], 32)
    ], 512), [
      [_vShow, !submitted.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, _cache[8] || (_cache[8] = [
      _createElementVNode("p", null, "Thanks, your request has been received. Our team will follow up with you shortly.", -1)
    ]), 512), [
      [_vShow, submitted.value]
    ]),
    _createElementVNode("p", _hoisted_4, [
      _createVNode(_component_router_link, {
        to: {name: 'SignIn'},
        class: "link"
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode(" Return to Customer Login ")
        ])),
        _: 1,
        __: [9]
      })
    ])
  ]))
}
}

})